import type { FaireProductEntity } from "../../entity_types/product";

export const p_s7mxah3gtv: FaireProductEntity = {
  token: "p_s7mxah3gtv",
  type: "product",
  name: "Roussa 18K Gold Non-Tarnish CZ Chain Earring Set",
  brandToken: "b_3tzh9mjdm6",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/1bd22844c72932e8d08214acb3d50dde63feab6819f72b5f6caa3330f666f4ea.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dad70af563de0ef9ea5acf79bf495b9f191c9143245557b683c48427d892d646.jpeg",
    "https://cdn.faire.com/fastly/e551287e8add6db932511c84d86b57440dee5656c3cfacb99f39aba4c41db4c0.jpeg",
    "https://cdn.faire.com/fastly/99aaf150e04393fb27bda03d5558e2fc491e550a7d5b238e9c7ec71f6ad78558.jpeg",
  ],
  priceDollars: 23.56,
  description:
    "18K Gold Non-Tarnish CZ Chain Earring Set\n18K Gold Plating\nStainless Steel \nCubic Zirconia\nMeasurement: \nRound Stud -0.13\nChain Stud - 1.76\nHoop CZ- 0.31\n\n- Lead-free, Nickel-safe\n- Hypoallergenic\n- Water Resistant",
  tags: [],
  msrpDollars: 47.11,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:27.581Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
